const plan_en = {
  projectNumber: 'Project No.',
  title: 'My Plans',
  search: 'Search',
  viewArchived: 'View Archived',
  newPlan: 'New Plan',
  noPlans: 'No Plans Found',
  filter: {
    allPlans: 'All Plans',
    byType: 'Planning Type',
  },
  status: {
    draft: 'Draft',
    ordered: 'Order Placed',
    confirmed: 'Confirmed',
    planned: 'Planned',
    packing: 'Packing',
    packed: 'Packed',
    setup: 'Setup',
    setuped: 'Set Up',
    active: 'Event Active',
    shipped: 'Shipped',
    retourned: 'Returned',
    packdown: 'Packdown',
    complete: 'Complete',
  },
  actions: {
    confirm: 'Confirm',
  },
  tooltipView: 'View plan',
  tooltipEdit: 'Edit plan',
  tooltipDelete: 'Delete plan',
  delete: 'Delete',
  deleteConfirm: 'Delete Plan',
  deleteConfirmMessage: 'Are you sure you want to delete this plan? This action cannot be undone.',
  deleteSuccess: 'Plan deleted successfully',
  deleteError: 'Failed to delete plan',
  editWindow: {
    editableUntil: 'Editable until {date}',
    editableUntilSoon: 'Editable until {date} - {days} days left',
    locked: 'Editing closed on {date}',
    eventStarted: 'Event start date has already passed',
    adminOverride: 'Exhibitor editing closed on {date} - admin access still applies',
    lockedTitle: 'Editing is closed',
    lockedMessage:
      'This plan can no longer be changed. The deadline was {date}, {days} days before the first setup or shipping day. Please contact your La Concept contact person if you still need a change.',
    saveRejected:
      'The editing deadline ({date}) has passed - your changes were not saved. The plan is now view-only.',
    saveRejectedGeneric: 'Something went wrong - your changes have not been saved.',
  },
  form: {
    tradeFairData: 'Trade Fair Data',
    itemsAndSets: 'Items And Sets',
    summary: 'Summary',
    serviceDescription: 'Complete delivery and assembly service by trade fair builder',
    serviceDescriptionShipping: 'Delivery service by trade fair builder',

    tradeFire: 'Trade Fair',
    booth: 'Booth',
    billingAddress: 'Billing Address',
    // planning type
    exhibition_setup: 'Setup',
    shipping: 'Shipping',
    selectPlanningTypePrompt: 'Select a planning type above to get started.',
    // Headers
    planningName: 'Planning Name',
    description: 'Description',
    planningType: 'Planning Type',
    exhibitionStartDate: 'Exhibition Start Date',
    exhibitionStartTime: 'Start Time',
    exhibitionStartTimePlaceholder: 'Start time (optional)',
    exhibitionEndDate: 'Exhibition End Date',
    exhibitionEndTime: 'End Time',
    exhibitionEndTimePlaceholder: 'End time (optional)',
    deliveryDay: 'Delivery Date',
    deliveryDayTime: 'Delivery Time',
    deliveryDayTimePlaceholder: 'Delivery time (optional)',
    collectionDay: 'Collection Date',
    collectionDayTime: 'Collection Time',
    collectionDayTimePlaceholder: 'Collection time (optional)',
    timeWindowFromPlaceholder: 'From (optional)',
    timeWindowToPlaceholder: 'Until (optional)',
    status: 'Status',
    // Document upload
    uploadLabel: 'Upload (Stand sketch, hall plan, access sketch, etc.)',
    selectFile: 'Select File',
    previewPdf: 'Preview PDF',
    documentType: 'Document Type',
    documentTypePlaceholder: 'Select a document type',
    documentTypeFirstHint: 'Pick a type first, then choose a file.',
    documentTypes: {
      STANDSKIZZE: 'Booth Sketch',
      HALLENPLAN: 'Hall Plan',
      AUFBAUAUSWEISE: 'Setup Passes',
      MESSEINFORMATIONEN: 'Fair Information',
      VERSANDETIKETT: 'Shipping Label',
      BEGLEITSCHREIBEN: 'Accompanying Letter',
      DOKUMENT: 'Other',
    },
    documentNote: 'Notes..',
    removeDocument: 'Remove',
    uploadError: 'Failed to upload document',
    documentUploadFailed:
      'One document could not be uploaded and has been kept so you can try again | {count} documents could not be uploaded and have been kept so you can try again',
    noDocuments: 'No documents uploaded yet.',
    // Event Address
    eventAddress: 'Event Address',
    deliveryAddress: 'Delivery Address',
    placeName: 'Venue',
    department: 'Department',
    streetAddress: 'Street Address',
    postalCode: 'Postal Code',
    city: 'City',
    country: 'Country',
    differentPickupAddress: 'Different collection address?',
    pickupAddress: 'Collection Address',
    pickupPlaceName: 'Place Name',
    pickupDepartment: 'Department',
    pickupStreetAddress: 'Street Address',
    pickupPostalCode: 'Postal Code',
    pickupCity: 'City',
    pickupCountry: 'Country',
    addressLookup: {
      unknownPostalCode:
        'Postal code not found — please double-check or enter the address manually.',
      contradictionCity: 'Suggested city "{city}" does not match what you entered.',
      contradictionPostal: 'Suggested postal code "{postal}" does not match what you entered.',
    },
    // Shipping (legacy keys kept for compatibility)
    street: 'Street',
    address1: 'Address 1',
    address2: 'Address 2',

    // booth type options

    // booth
    boothType: 'Booth Type',
    boothNumber: 'Booth Number',
    boothDimensions: 'Booth Dimensions',
    boothArea: 'Stand Size',
    boothDimWidth: 'Width',
    boothDimHeight: 'Height',
    boothDimDepth: 'Depth',
    hall: 'Hall',
    customerContactPerson: 'Customer Contact Person',
    contactPersonUnavailable: 'Contact no longer in Work4All',
    laConceptContact: 'LA CONCEPT Contact',
    customerContactPersonModeExisting: 'Select a stored contact',
    customerContactPersonModeFreeText: 'Enter someone else',
    customerContactPersonName: 'Name',
    customerContactPersonNamePlaceholder: 'Full name',
    customerContactPersonPhone: 'Phone (optional)',
    customerContactPersonEmail: 'Email (optional)',
    setupDays: 'Setup Days',
    addSetupDay: 'Add Day',
    noSetupDays: 'No setup days added yet.',
    dismantlingDays: 'Dismantling Days',
    addDismantlingDay: 'Add Day',
    noDismantlingDays: 'No dismantling days added yet.',
    setupDayDate: 'Date',
    setupDayStartTime: 'Start Time',
    setupDayEndTime: 'End Time',
    otherInformation: 'Other Information',
    generalInformation: 'General Information',
    internalOrderNumber: 'Internal Order Number',
    additionalEquipment: 'Additional equipment required',
    additionalEquipmentNote: 'What is needed?',
    materialWillBeDelivered: 'Material will be delivered',
    materialDeliveryDate: 'Delivery Date',
    materialDeliveryTime: 'Delivery Time',
    materialDeliveryTimePlaceholder: 'Delivery time (optional)',
    materialDeliveryNote: 'Scope (number of pallets, number of packages)',
    yes: 'Yes',
    no: 'No',
    boothHandover: 'Stand handover desired?',
    boothHandoverType: 'Type',
    boothHandoverTypePersonal: 'Personal Handover',
    boothHandoverTypeDigital: 'Digital Handover',
    boothHandoverContactPerson: 'Contact Person',
    boothHandoverMobile: 'Mobile Number',
    boothHandoverMobileOrEmail: 'Mobile Number / Email',
    boothHandoverDigitalType: 'Contact Type',
    boothHandoverDigitalTypePlaceholder: 'e.g. WhatsApp, Email',
    boothHandoverDate: 'Handover Date',
    boothHandoverTime: 'Handover Time',
    boothHandoverTimePlaceholder: 'Select time',

    // status options
    draft: 'Draft',
    ordered: 'Ordered',
    // buttons
    cancel: 'Cancel',
    continue: 'Continue',
    confirmOrder: 'Confirm Order',
    saveChanges: 'Save Changes',
    saveAsDraft: 'Save as draft',
    back: 'Back',
    stay: 'Stay',
    leave: 'Leave',
    addItems: 'Add Items',
    // confirm modal
    confirmBack: 'Unsaved Changes',
    confirmBackMessage: 'You have unsaved changes. Are you sure you want to leave this page?',
    confirmOrderModalTitle: 'Confirm Order',
    confirmOrderModalMessage: 'Are you ready to submit your plan and confirm this order?',
    tradeFair: 'Trade Fair',
    // Success/Error messages
    loadError: 'Failed to load plan data',
    createSuccess: 'Plan created successfully',
    updateSuccess: 'Plan updated successfully',
    createError: 'Failed to create plan',
    updateError: 'Failed to update plan',
    submitSuccess: 'Plan submitted successfully',
    submitError: 'Failed to submit plan',
    validationError: 'Please fill in all required fields',
    validationErrorTitle: 'Missing required fields',
    itemsSaveSuccess: 'Items saved successfully',
    draftSaveSuccess: 'Saved as draft',
    itemsSaveError: 'Failed to save items',
    itemsClearFailed:
      'One item could not be removed and is still in the planning | {count} items could not be removed and are still in the planning',
    // Errors
    errors: {
      boothHandoverContactInvalid: 'Please enter a valid mobile number or email address',
      boothHandoverMobileInvalid: 'Please enter a valid mobile number',
      cityRequired: 'City is required',
      customerContactPersonNameRequired: 'Please enter a name for the on-site contact person',
      customerContactPersonNameTooLong: 'Name must be 150 characters or fewer',
      customerContactPersonPhoneInvalid: 'Please enter a valid phone number',
      customerContactPersonEmailInvalid: 'Please enter a valid email address',
      documentTypeRequired: 'Please select a document type for every uploaded document',
      countryRequired: 'Country is required',
      exhibitionEndDateBeforeStart: 'End date cannot be before the start date',
      timeWindowEndBeforeStart: 'The end time cannot be before the start time',
      exhibitionEndDateRequired: 'Exhibition end date is required',
      exhibitionStartDateRequired: 'Exhibition start date is required',
      planningNameRequired: 'Planning name is required',
      planningTypeRequired: 'Planning type is required',
      postalCodeRequired: 'Postal code is required',
      streetRequired: 'Street is required',
    },
  },
  step2: {
    itemSets: 'Item Sets',
    useThisSet: 'Use This Set',
    removeThisSet: 'Remove This Set',
    addSet: 'See Your Sets',
    hideSets: 'Hide Sets',
    groupView: 'Group View',
    listView: 'List View',
    search: 'Search',
    filter: 'Filter',
    filterTitle: 'Filter Items',
    category: 'Category',
    selectCategory: 'Select a category',
    apply: 'Apply',
    cancel: 'Cancel',
    selectedItems: 'Selected Items',
    removeItem: 'Remove item',
    quantity: 'Quantity',
    quantityOf: 'Quantity of {name}',
    increaseQuantity: 'Increase the quantity of {name}',
    decreaseQuantity: 'Decrease the quantity of {name}',
    rentItem: 'Rent Item',
    ownItem: 'Own Item',
    showAll: 'Show All',
    stillAvailable: '{count}x Available',
    showRental: 'Show rental items',
    onlyAvailable: 'Only available items',
    // Loading messages, without trailing dots — the loader animates them.
    availabilityLoading: {
      checking: 'Checking item availability',
      stock: 'Reading warehouse stock levels',
      exhibition: 'Checking for exhibition availability',
      compiling: 'Putting together available items',
    },
    widthDepthHeight: 'Width x Depth x Height',
    weight: 'Weight',
    name: 'Name',
    itemInfo: 'Item Info',
    itemType: 'Item Type',
    availability: 'Availability',
    price: 'Price',
  },
  step3: {
    summaryDescription: 'Review your plan details before submitting.',
    tracking: 'Shipment tracking',
    outboundTracking: 'Outbound shipment',
    returnTracking: 'Return shipment',
    trackShipment: 'Track shipment',
    visualizations: 'Visualizations',
    boothPhotos: 'Booth handover',
    boothPhotosHint: 'Photos of the built booth, taken by the booth builder.',
    shippingPhotos: 'Shipping photos',
    shippingPhotosHint: "The assembler's photos of the goods as they are shipped.",
    openFile: 'Open file',
    uploads: 'Uploads (Stand sketch, hall plan, access sketch, etc.)',
    orderSummary: 'Order Summary',
    name: 'Name',
    quantity: 'Quantity',
    noItemsSelected: 'No items selected',
    uncategorized: 'No category',
    status: 'Status',
    requested: 'Requested',
    confirmed: 'Confirmed',
    selected: 'Selected',
    checking: 'Checking...',
    available: 'Available',
    unavailable: 'Unavailable',
    itemUnavailable: '{available} available, {requested} requested',
    unavailableWarning:
      'Some of the selected items are not available for the specified dates. We will be happy to contact you to discuss this further.',
  },
}

export default plan_en
